// 沒照片時的占位（從 prototype 的 PhB 改造）
export default function Placeholder({ kind = "otherworld", label = "尚未上傳" }) {
  return (
    <div className={`ph ph-${kind}`}>
      <span className="ph-lbl">{label}</span>
    </div>
  );
}
